module.exports = __webpack_public_path__ + "img/s2.60c816d8.jpg";